import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  containerized: {
    type: 'boolean',
    default: true,
  },
  variant: {
    type: 'string',
    default: 'default',
  },
  titleVariant: {
    type: 'string',
    default: 'title-6',
  },
  titleColor: {
    type: 'string',
    default: 'color-black',
  },
  titleMargin: {
    type: 'string',
    default: 'margin-extra-small',
  },
  useIn: {
    type: 'string',
    default: 'accordion',
  },
  placeholder: {
    type: 'string',
    default: 'Digite a sua dúvida',
  },
  ...Common,
};
